<template lang="pug">
    section#banner
        Imagem(:content="content", v-if="content != undefined")
        ul.redes
            li.rede(v-if="$configuracoes.instagram")
                a(:href="$configuracoes.instagram", target="_blank")
                    FontAwesomeIcon(:icon="icons.faInstagram")
            li.rede(v-if="$configuracoes.facebook")
                a(:href="$configuracoes.facebook", target="_blank")
                    FontAwesomeIcon(:icon="icons.faFacebook")
</template>

<script>
import { faFacebookSquare as faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { components } from '@/mixins/components'

export default {
    name: "component-banner",
    components,
    props: {
        content: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            icons: {
                faFacebook, 
                faInstagram,
            },
        }
    },
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>